/**
 * navigation.js starts
 * Created by mac on 20.08.2018.
 */

MainMenu = {
  submenuState: 'closed',
  options: {
    menuId: 'mainmenu',
    smWrapper: 'submenu-wrapper',
    smContainer: 'container',
    submenuId: 'submenu',
    submenuList: '.submenu-list',
    currentItem: 'current-item',
    bodyActiveClass: 'submenu-enabled',
    currMenuWrapper: 'curr-menu-wrapper'
  },
  init: function () {
    var opts    = this.options;
    var menu    = document.getElementById(opts.menuId),
        submenu = menu.querySelectorAll(opts.submenuList);
    
    var activeFlag = false;
    
    if (submenu) {
      for (var i = 0; i < submenu.length; i++) {
        if (this.checkActive(submenu[i]))
          activeFlag = true;
        
        this.wrapSubmenu(submenu[i]);
      }
    }
    
    if (activeFlag) {
      document.body.classList.add(opts.bodyActiveClass);
      this.drawCurrMenu();
    }
    
    
  },
  checkActive: function (submenu) {
    var activeFlag = false;
    if (submenu)
      if (submenu.parentNode.classList.contains('active'))
        activeFlag = true;
      else
        activeFlag = false;
    
    return activeFlag;
  },
  /*Дублирует текущее активное подменю (чтобы было открыто)*/
  drawCurrMenu: function() {
    var opts = this.options,
        currMenuWrapper = document.getElementById(opts.currMenuWrapper),
        menu = document.getElementById(opts.menuId),
        activeSubmenu = menu.querySelector('.active .submenu-list');
   
    if (activeSubmenu && currMenuWrapper) {
      var currMenu = activeSubmenu.cloneNode(true);
      var currMenuContainer = document.createElement('div');
      
      currMenuContainer.classList.add('container');
      currMenuContainer.appendChild(currMenu);
      currMenuWrapper.appendChild(currMenuContainer);
      currMenuWrapper.style.display = 'block';
    }
  },
  wrapSubmenu: function (submenu) {
    var o = this.options;
    if (submenu) {
      var parent      = submenu.parentNode,
          smWrapper   = document.createElement('div'),
          smContainer = document.createElement('div');
      
      smWrapper.classList.add(o.smWrapper);
      smContainer.classList.add(o.smContainer);
      smContainer.appendChild(submenu);
      smWrapper.appendChild(smContainer);
      parent.appendChild(smWrapper);
      
    }
    else
      return false;
  },
  toggle: function (link) {
    var state,
        opts = this.options;
    
    if (link.classList.contains(opts.currentItem)) {
      state = this.close(link);
    }
    else {
      state = this.open(link);
    }
    
    this.submenuState = state;
  },
  open: function (link) {
    
    var opts           = this.options,
        submenuWrapper = document.getElementById(opts.submenuWrapperId),
        menu           = document.getElementById(opts.menuId),
        oldLink        = menu.querySelector('.' + opts.currentItem), //предыдущая активная ссылка
        state          = "opened";
    
    if (oldLink) //удаляем класс активности с предыдущей активной ссылки, если такая есть
      oldLink.classList.remove(opts.currentItem);
    
    $(submenuWrapper).collapse('show'); //разворачиваем панель с субменю
    $(link).tab('show'); //активируем текущий таб субменю
    link.classList.add(opts.currentItem); //добавляем класс активности текущей активной ссылки
    
    return state;
  },
  close: function (link) {
    var opts           = this.options,
        submenuWrapper = document.getElementById(opts.submenuWrapperId),
        state          = 'closed';
    link.classList.remove(opts.currentItem);
    $(submenuWrapper).collapse('hide');
    return state;
  },
  showBg: function(li){
    var bg = document.querySelector('.nav-main-bg');
    var wDoc = document.body.clientWidth;
        li.appendChild(bg);
        bg.style.width = wDoc + 'px';
        bg.classList.add('in');
  },
  hideBg: function(){
    var bg = document.querySelector('.nav-main-bg');
    bg.classList.remove('in');
  }
};

$(function () {
  
 // MainMenu.init();
  
  $(document).on('mouseenter', '.nav-main .dropdown:not(.active)', function(e){
  //    MainMenu.showBg(e.currentTarget);
  });
  $(document).on('mouseleave', '.nav-main .dropdown', function(e){
  //  MainMenu.hideBg();
  });
  
  
});

/* navigation.js ends */